import React, { useState } from 'react'
import PropTypes from 'prop-types'
import shallowEqual from 'shallowequal'
import CarouselThumbnail from '../thumbnails-item/CarouselThumbnail'
import { isShowPrev, isShowNext, getMaxThumbnails } from './utils'

const CarouselThumbnailList = ({ images, currentIdx }) => {
  const [skipThumbnails, setSkipThumbnails] = useState(0)
  const totalImg = images.length

  const maxThumbnails = getMaxThumbnails(totalImg)

  const diff = totalImg - maxThumbnails

  const handlePrev = () => {
    if (!shallowEqual(skipThumbnails, 0)) {
      setSkipThumbnails(skipThumbnails - 1)
    }
  }

  const handleNext = () => {
    if (!shallowEqual(skipThumbnails, diff)) {
      setSkipThumbnails(skipThumbnails + 1)
    }
  }

  return (
    <React.Fragment>
      {isShowPrev(totalImg, currentIdx) && (
        <svg
          className="pdp__carousel-arrow-up"
          onClick={handlePrev}
          width="18"
          height="11"
          viewBox="0 0 18 11"
          data-cy="up-arrow"
        >
          <path
            fill="none"
            fillRule="evenodd"
            stroke="#000"
            strokeWidth="2"
            d="M1 9.946L8.966 2 17 10"
            opacity=".25"
          />
        </svg>
      )}
      {images.map((img, idx) => (
        <CarouselThumbnail
          key={img.full_path || img.full_cover_image_path}
          img={img}
          idx={idx}
          currentIdx={currentIdx}
          totalImg={totalImg}
          maxThumbnails={maxThumbnails}
          skipThumbnails={skipThumbnails}
          setSkipThumbnails={setSkipThumbnails}
        />
      ))}
      {isShowNext(totalImg, currentIdx) && (
        <svg
          className="pdp__carousel-arrow-down"
          onClick={handleNext}
          width="18"
          height="11"
          viewBox="0 0 18 11"
          data-cy="down-arrow"
        >
          <path
            fill="none"
            fillRule="evenodd"
            stroke="#000"
            strokeWidth="2"
            d="M1 1.054L8.966 9 17 1"
            opacity=".249"
          />
        </svg>
      )}
    </React.Fragment>
  )
}

CarouselThumbnailList.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      full_path: PropTypes.string,
      full_cover_image_path: PropTypes.string,
    }),
  ).isRequired,
  currentIdx: PropTypes.number.isRequired,
}

export default CarouselThumbnailList
